export default __webpack_public_path__ + "static/media/Video1.4b4065ca.mp4";